import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../ui/PageContainer';
import { fetchBrandKit, type BrandKit } from '../../services/editingApi';
import BrandKitDialog from './BrandKitDialog';

/** The brand kit on its own page (the account menu's "Brand kit"): the same dialog, closed back to where you were. */
const BrandKitPage: React.FC = () => {
  const navigate = useNavigate();
  const [kit, setKit] = useState<BrandKit | null>(null);
  const [problem, setProblem] = useState<string | null>(null);
  useEffect(() => {
    fetchBrandKit().then(setKit).catch((error) => setProblem(error instanceof Error ? error.message : 'Your brand kit couldn’t be loaded.'));
  }, []);
  const close = () => (window.history.length > 1 ? navigate(-1) : navigate('/library?tab=edits'));
  return (
    <PageContainer>
      {problem ? <Alert severity="error">{problem}</Alert> : null}
      {!kit && !problem ? <Box sx={{ py: 8, display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : null}
      {kit ? <BrandKitDialog open kit={kit} onClose={close} onKit={setKit} /> : null}
    </PageContainer>
  );
};

export default BrandKitPage;
